import { getItemStorage } from '../../commons';

const getAuthorization = () => {
  const result = getItemStorage(process.env.REACT_APP_TOKEN_AUTH_NAME);
  return result;
}

export default getAuthorization;
